<div>
  <shr-checkbox *ngFor="let program of programsToDisplay"
    tabindex="0"
    [controlId]="program"
    [label]="program.toUpperCase()"
    [(checked)]="selectedPrograms[program]"
    (checkedChange)="emit()"
  ></shr-checkbox>
</div>
